import apiRequest from 'client/helpers/apiRequest';
import Settings from '@interfaces/settings';
import HeadMenu from '@interfaces/head-menu';
import CustomPage from '@interfaces/custom-page';

export const fetchSettings = () => apiRequest.get<Settings>('/api/settings');

export const fetchAppMenu = () => apiRequest.get<HeadMenu>('/api/headMenu');

export const fetchCustomPage = (slug: string) => apiRequest.get<CustomPage>(`/api/customPages/${slug}`);
